<script>
  import { Link, imgSrc } from '$client';
  export let data;
  const info = data.attributes;
</script>

<li>
  <Link href="/usluga-{info.url}">
    <img
      loading="lazy"
      height={info.pageImg.data.attributes.height}
      width={info.pageImg.data.attributes.width}
      src={imgSrc(info.pageImg.data.attributes.url)}
      alt={info.ancor} />
    <span>{info.ancor}</span>
  </Link>
</li>

<style lang="scss">
  li {
    width: 100%;

    :global(a) {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 100%;
    }
  }

  span {
    color: rgb(44 51 60 / 100%);
    font-weight: 600;
    font-size: 16px;
    font-family: Vela-Sans, sans-serif;
  }

  img {
    width: 100%;
    min-width: 200px;
    height: 200px;
    object-fit: cover;
    object-position: left;
    border-radius: 15px;

    @media only screen and (max-width: 767.98px) {
      width: 100%;
      font-size: 25px;
    }

    @media only screen and (max-width: 575.98px) {
      font-size: 20px;
    }
  }
</style>
